import React, { Component } from 'react'
import { Row, Col, Carousel } from 'antd';

class Icons extends Component {
  constructor(props) {
    super(props);
    this.carousel = React.createRef();
  }
  componentDidMount = () => {
    setTimeout(() => this.next(), 10000)
  }
  next = () => {
    this.carousel && this.carousel.next();
    setTimeout(() => this.next(), 10000)
  }
  render() {

    const propsCarousel = {
      dots: false,
      infinite: true,
      speed: 2500,
      slidesToShow: 1,
      slidesToScroll: 1
    };

      return (
        <Row>
          <Col span={24}>
            <Carousel ref={node => (this.carousel = node)} effect="fade" {...propsCarousel}>
              <div>
                <div className="main-icons">
                  <Col xs={{ span: 6, offset: 0 }} sm={{ span: 5, offset: 0 }} md={{ span: 5, offset: 0 }} lg={{ span: 5, offset: 0 }}>
                    <div style={{backgroundImage: 'url(/images/home/1.png)'}} />
                  </Col>
                  <Col xs={{ span: 6, offset: 0 }} sm={{ span: 5, offset: 0 }} md={{ span: 5, offset: 0 }} lg={{ span: 5, offset: 0 }}>
                    <div style={{backgroundImage: 'url(/images/home/2.png)'}} />
                  </Col>
                  <Col xs={{ span: 6, offset: 0 }} sm={{ span: 4, offset: 0 }} md={{ span: 4, offset: 0 }} lg={{ span: 4, offset: 0 }}>
                    <div style={{backgroundImage: 'url(/images/home/5.png)'}} />
                  </Col>
                  <Col xs={{ span: 6, offset: 0 }} sm={{ span: 5, offset: 0 }} md={{ span: 5, offset: 0 }} lg={{ span: 5, offset: 0 }}>
                    <div style={{backgroundImage: 'url(/images/home/3.png)'}} />
                  </Col>
                  <Col xs={{ span: 0, offset: 0 }} sm={{ span: 5, offset: 0 }} md={{ span: 5, offset: 0 }} lg={{ span: 5, offset: 0 }}>
                    <div style={{backgroundImage: 'url(/images/home/4.png)'}} />
                  </Col>
                </div>
              </div>
              <div>
                <div className="main-icons">
                  <Col xs={{ span: 6, offset: 0 }} sm={{ span: 5, offset: 0 }} md={{ span: 5, offset: 0 }} lg={{ span: 5, offset: 0 }}>
                    <div style={{backgroundImage: 'url(/images/home/6.png)'}} />
                  </Col>
                  <Col xs={{ span: 6, offset: 0 }} sm={{ span: 5, offset: 0 }} md={{ span: 5, offset: 0 }} lg={{ span: 5, offset: 0 }}>
                    <div style={{backgroundImage: 'url(/images/home/7.png)'}} />
                  </Col>
                  <Col xs={{ span: 6, offset: 0 }} sm={{ span: 4, offset: 0 }} md={{ span: 4, offset: 0 }} lg={{ span: 4, offset: 0 }}>
                    <div style={{backgroundImage: 'url(/images/home/10.png)'}} />
                  </Col>
                  <Col xs={{ span: 6, offset: 0 }} sm={{ span: 5, offset: 0 }} md={{ span: 5, offset: 0 }} lg={{ span: 5, offset: 0 }}>
                    <div style={{backgroundImage: 'url(/images/home/8.png)'}} />
                  </Col>
                  <Col xs={{ span: 0, offset: 0 }} sm={{ span: 5, offset: 0 }} md={{ span: 5, offset: 0 }} lg={{ span: 5, offset: 0 }}>
                    <div style={{backgroundImage: 'url(/images/home/9.png)'}} />
                  </Col>
                </div>
              </div>
            </Carousel>
          </Col>
        </Row>
      )
  }
}

export default Icons
